import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  TextField,
} from "@material-ui/core";
import Switch from '@mui/material/Switch';
import FormControl from '@mui/material/FormControl';
import { alpha, styled } from '@mui/material/styles';
import { pink } from '@mui/material/colors';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    padding: "3vh 3%",
    "@media (max-width: 600px)": {
      padding: "3vh 0%",
      marginLeft: "-15px",
      width: "109%",
    },
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
  },
  cardActions: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "15px",
  },
  title: {
    margin: "10px 0",
  },
  input: {
    margin: "10px 0",
  },
}));

const PinkSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: pink[600],
    '&:hover': {
      backgroundColor: alpha(pink[600], theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: pink[600],
  },
}));


export default ({ onSubmit, openToast, isLoading, baseGalleryData }) => {
  const classes = useStyles();
  const [type, setType] = React.useState(baseGalleryData._id ? baseGalleryData.category : 'video');

  const handleType = (event) => {
    setType(event.target.value);
  };
  const [external, setExternal] = React.useState({extenalLink:false});
  const [state, setState] = useState(
    baseGalleryData._id
      ? {
          title: baseGalleryData.title,
          category: baseGalleryData.category,
          videoUrl: baseGalleryData.videoUrl,
          thumbnail: baseGalleryData.thumbnail
        }
        : {
          title: "",
          category: "",
          videoUrl: "",
          thumbnail:""
        }
  );
  
  const handleChange = (event) => {
    const { id, value } = event.target;
    console.log(id, value);
    
    setState({ ...state, [id]: value });
  };

  const handleSubmit = () => {
      state.category = type;
      // state.thumbnail = state.videoUrl
    if ((!state.title, !state.category, !state.videoUrl) && !external.extenalLink) {
      return openToast({
        message: "An image field can not be Empty",
        type: "warning",
      });
    }
    onSubmit(state);
    setState({
      videoUrl:"",
      title:""
    })
  };


  return (
    <Container justify="center" maxWidth="md">
      <Card className={classes.cardRoot}>
        <CardHeader title={baseGalleryData._id ? `Update Video` : `Upload a new Video`} />
        <CardContent className={classes.cardContent}>
          <TextField
            id="title"
            label="caption"
            variant="outlined"
            required
            className={classes.title}
            value={state.title}
            onChange={handleChange}
          />
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Category</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={type}
              label="Category"
              disabled
              onChange={handleType}
            >
              <MenuItem value="video">Videos</MenuItem>
            </Select>
          </FormControl>
          <TextField
            id="videoUrl"
            label="external link"
            required
            variant="outlined"
            className={classes.title}
            value={state.videoUrl}
            onChange={handleChange}
          />
          
          <TextField
            id="thumbnail"
            label="Video Thumbnail"
            required
            value={state.thumbnail}
            onChange={handleChange}
            variant="outlined"
            className={classes.input}
          />
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Button
            variant="outlined"
            onClick={handleSubmit}
            disabled={ state.videoUrl.trim() === "" || state.title.trim() === "" || state.thumbnail.trim() === ""}
            sx={{
              color: "#E00186",
              border: "1px solid #E00186",
              "&:hover": {
                color: "#fff",
                backgroundColor: "#E00186",
                border: "1px solid #E00186",
              },
            }}
          >
            Upload Video
          </Button>
        </CardActions>
      </Card>
    </Container>
  );
};
